<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :loading="loading"
      >
        <template slot="times" slot-scope="text, record">
          {{ record.default_start_time }} - {{ record.default_end_time }}
        </template>
        <template slot="status" slot-scope="text">
          <span v-if="text === 1" class="badge badge-success">Active</span>
          <span v-else class="badge badge-danger">Inactive</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Schedule Override -->
            <a-tooltip title="Override Schedule">
              <a href="javascript:;" class="btn btn-sm btn-info mr-2"
                 @click="showScheduleModal(record)"
              >
                <i class="fe fe-calendar" />
              </a>
            </a-tooltip>

            <!-- Edit -->
            <a-tooltip title="Edit Session">
              <a href="javascript:;" class="btn btn-sm btn-light mr-2"
                 @click="showEditModal(record)"
              >
                <i class="fe fe-edit" />
              </a>
            </a-tooltip>

            <!-- Delete -->
            <a-tooltip title="Delete Session">
              <a href="javascript:;" class="btn btn-sm btn-danger"
                 @click="onDelete(record)"
              >
                <i class="fe fe-trash" />
              </a>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <edit-session @onEdited="handleAfterEdit" />
    <schedule-override @onScheduled="handleAfterEdit" />
  </div>
</template>

<script>
import EditSession from '@/components/tuition/manage/session/Edit'
import ScheduleOverride from '@/components/tuition/manage/session/Schedule'

const columns = [
  { title: 'Session Name', dataIndex: 'name', key: 'name' },
  { title: 'Code', dataIndex: 'code', key: 'code' },
  { title: 'Default Timing', key: 'times', scopedSlots: { customRender: 'times' } },
  { title: 'Status', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } },
  { title: 'Actions', key: 'action', scopedSlots: { customRender: 'action' }, width: 150, className: 'text-right' },
]

export default {
  name: 'TuitionSessionTable',
  components: {
    EditSession,
    ScheduleOverride,
  },
  props: {
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    showEditModal(record) {
      this.$eventBus.$emit('openEditTuitionSession', record)
    },
    showScheduleModal(record) {
      this.$eventBus.$emit('openTuitionSessionSchedule', record)
    },
    handleAfterEdit() {
      this.$emit('updateTable')
    },
    onDelete(record) {
      this.$confirm({
        title: 'Are you sure you want to delete this session?',
        content: `You are about to delete "${record.name}". This may affect enrollments.`,
        okText: 'Yes, Delete',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/tuition/sessions/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification.success({
                message: 'Deleted Successfully!',
                description: `Session "${record.name}" has been deleted.`,
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
      })
    },
  },
}
</script>
